module.exports = __webpack_public_path__ + "img/image-(1)_thumbnail.b10e709f.jpg";